'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _blacklist = require('blacklist');

var _blacklist2 = _interopRequireDefault(_blacklist);

var _constants = require('../constants');

var _constants2 = _interopRequireDefault(_constants);

var Container = function Container(props) {
    var gutter = props.gutter;
    var maxWidth = props.maxWidth;

    var containerStyle = {
        marginLeft: 'auto',
        marginRight: 'auto',
        paddingLeft: gutter,
        paddingRight: gutter,
        maxWidth: maxWidth
    };
    var clearfixStyle = { clear: 'both', display: 'table' };
    var rest = (0, _blacklist2['default'])(props, 'gutter', 'maxWidth', 'style');

    return props.clearfix ? _react2['default'].createElement(
        'div',
        _extends({}, rest, { style: _extends(containerStyle, props.style) }),
        _react2['default'].createElement('span', { style: clearfixStyle }),
        props.children,
        _react2['default'].createElement('span', { style: clearfixStyle })
    ) : _react2['default'].createElement('div', _extends({}, rest, { style: _extends(containerStyle, props.style) }));
};

Container.propTypes = {
    children: _propTypes2['default'].node.isRequired,
    clearfix: _propTypes2['default'].bool,
    gutter: _propTypes2['default'].number,
    maxWidth: _propTypes2['default'].number,
    style: _propTypes2['default'].object
};

Container.defaultProps = {
    gutter: _constants2['default'].width.gutter,
    maxWidth: _constants2['default'].width.container
};

module.exports = Container;


//////////////////
// WEBPACK FOOTER
// /causemisspiggynodeweb-ci-9188/workspace/Release/~/kepler/lib/components/Container.js
// module id = 282
// module chunks = 0